interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | '…')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('…');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('…');
    pages.push(totalPages);
  }

  const btnStyle = (active: boolean, disabled?: boolean): React.CSSProperties => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '32px',
    height: '32px',
    padding: '0 var(--space-2)',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: 600,
    border: '1px solid var(--line)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    background: active ? 'var(--navy)' : 'var(--paper)',
    color: active ? '#fff' : disabled ? 'var(--slate-2)' : 'var(--navy)',
    opacity: disabled ? 0.5 : 1,
    transition: 'background .12s',
  });

  return (
    <nav aria-label="Lapozás" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1)', flexWrap: 'wrap' }}>
      <button
        style={btnStyle(false, page === 1)}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        aria-label="Előző oldal"
      >
        ‹
      </button>
      {pages.map((p, i) =>
        p === '…' ? (
          <span key={`ellipsis-${i}`} style={{ padding: '0 4px', color: 'var(--slate)' }}>…</span>
        ) : (
          <button
            key={p}
            style={btnStyle(p === page)}
            onClick={() => onPageChange(p as number)}
            aria-label={`${p}. oldal`}
            aria-current={p === page ? 'page' : undefined}
          >
            {p}
          </button>
        )
      )}
      <button
        style={btnStyle(false, page === totalPages)}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        aria-label="Következő oldal"
      >
        ›
      </button>
    </nav>
  );
}
